import { useDispatch, useSelector } from "react-redux";
import "./recommended-questions.component.scss";
import {
  questionAsked,
  showRecommendedQuestions,
} from "../../state/slice";
import { useEffect, useRef, useState } from "react";
import useApi from "../../hooks/useApi";
import useScreenSize from "../../hooks/useScreenSize";

const RecommendedQuestions = () => {
  const logo = require("../../assets/recomndquestion-ask.svg")?.default;
  // const logo1 = require("../../assets/world-cc-logo-only.ico");
  // const logo2 = require("../../assets/flags.svg")?.default;
  // const logo3 = require("../../assets/source-data.png");
  const loader = require("../../assets/loader-think.gif");

  const [questions, setQuestions] = useState<any[]>([]);
  const { post } = useApi();
  const currentUser = useSelector((state: any) => state.user);
  const currentInteractionId = useSelector((state: any) => state.interactionId);
  const currentChatHistoryId = useSelector((state: any) => state.chatHistoryId);
  const initialFetchController = useRef(new AbortController());

  const showAnswer = useSelector((state: any) => state.showAnswer);
  // const showSources = useSelector((state: any) => state.showSources);
  const [isLoading, setIsLoading] = useState(false);
  const loadermessage = "Generating follow-up questions...";
  const fetchRecommendedQuestions = async () => {
    if (currentUser?.id > -1 && currentInteractionId > -1 && showAnswer) {
      initialFetchController.current = new AbortController();

      setIsLoading(true);
      setQuestions([]);
      const param = {
        user_id: currentUser?.id,
        interaction_id: currentInteractionId,
      };
      const response: any = await post(
        "interactions/generate_followup",
        param,
        { signal: initialFetchController.current.signal },
      ); //http://13.42.222.63:9000/mock-followup
      setIsLoading(false);
      if (response && response?.data != null) {
        setQuestions(response?.data?.data);
        dispatch(showRecommendedQuestions());
      } else {
      }
    }
  };

  useEffect(() => {
    return () => {
      console.log("Aborting fetch in followup question...");
      initialFetchController.current.abort("AbortError"); // Abort the fetch when component unmounts
    };
  }, []);

  useEffect(() => {
    fetchRecommendedQuestions();
  }, [currentUser, currentInteractionId, showAnswer]);

  const dispatch = useDispatch();
  const { isMobile } = useScreenSize();

  // const openSourcePanel = () => {
  //   dispatch(openSources());
  // };

  const questionClicked = (value: string) => {
    dispatch(questionAsked(value));
  };

  const showLoaderMessage = () => {
    return (
      <div className="headerdiv" style={{ marginTop: "1%" }}>
        <img src={loader} alt="loader" />
        <span className="headingtim">{loadermessage}</span>
      </div>
    );
  };
  const renderForm = () => {
    return (
      <div className="recommendedQuestionsDiv" style={{marginBottom:currentChatHistoryId === -1 ? "40%" : "0px"}}>
        <div style={{ display: showAnswer && currentChatHistoryId === -1 ? "block" : "none" }}>
          {/* style={{ visibility: showAnswer ? "visible" : "hidden" }}> */}
          {isLoading && currentChatHistoryId === -1 && showLoaderMessage()}
          {!isLoading && <p>MORE RELATED QUESTIONS</p>}

          <ul className="list-group">
            {questions
              ?.filter((item) => item.trim() !== "")
              ?.map((item: any) => (
                <li
                  className="list-group-item d-flex justify-content-between"
                  key={item}
                >
                  {isMobile && (
                    <button
                      onClick={() => {
                        questionClicked(item);
                      }}
                    >
                      <img src={logo} alt="ask" />
                    </button>
                  )}
                  {item}
                  {!isMobile && (
                    <button
                      onClick={() => {
                        questionClicked(item);
                      }}
                    >
                      <img src={logo} alt="ask" />
                    </button>
                  )}
                </li>
              ))}
          </ul>
        </div>

        {/* <div
          className="allsources"
          onClick={openSourcePanel}
          style={{
            display: showSources && showAnswer ? "block" : "none",
          }}
        >
          Sources <img src={logo1} alt="logo"></img>
          <img src={logo2} alt="logo"></img>
          <img src={logo3} alt="logo"></img>
        </div> */}
      </div>
    );
  };

  return renderForm();
};

export default RecommendedQuestions;
